import React from "react"
import { Card, Table } from "reactstrap"
import PerfectScrollbar from "react-perfect-scrollbar"
import { Query } from "react-apollo"
import { useSubscription } from "@apollo/react-hooks"
import { Spinner } from "components/spinner"
import { chatRooms } from "gql/queries"
import { chatRoomUpdated } from "gql/subscriptions"
import ChatRoom from "./ChatRoom"

const ChatRoomList = () => {
  const { data } = useSubscription(chatRoomUpdated)

  const renderChatRooms = (chatRooms) => {
    if (chatRooms?.length === 0) {
      return (
        <tr>
          <td>目前無對話</td>
        </tr>
      )
    }

    return chatRooms?.map((chatroom, index) => (
      <tr key={index}>
        <td>
          <ChatRoom {...chatroom} />
        </td>
      </tr>
    ))
  }

  if (data && chatRoomUpdated) {
    return (
      <PerfectScrollbar>
        <Card>
          <Table>
            <tbody>{renderChatRooms(data?.chatRoomUpdated?.chatRooms)}</tbody>
          </Table>
        </Card>
      </PerfectScrollbar>
    )
  }

  return (
    <Query query={chatRooms} fetchPolicy="network-only">
      {({ loading, data }) => {
        if (loading) {
          return <Spinner />
        }

        return (
          <PerfectScrollbar>
            <Card>
              <Table>
                <tbody>{renderChatRooms(data?.chatRooms)}</tbody>
              </Table>
            </Card>
          </PerfectScrollbar>
        )
      }}
    </Query>
  )
}

export default ChatRoomList
